export function isCallback(x) {
  return x != null && typeof x === 'function';
}
export function isOptions(x) {
  return x != null && typeof x === 'object' && !(x instanceof Array);
}
export function isSerializableMap(x) {
  return x != null && typeof x === 'object' && !(x instanceof Array);
}
export var isDependencies = function isDependencies(x) {
  return x != null && x instanceof Array;
};
export var isArrayOfStrings = function isArrayOfStrings(x) {
  return x != null && x instanceof Array;
};
//# sourceMappingURL=generic.js.map